import { Stack } from "@mui/system";
import { ReactNode, useState } from "react";
import { CircularProgress } from "@mui/material";
import { CustomButton } from "../../CustomButton";
import { GradientButton } from "../../GradientButton";

type Props = {
  btnText: string;
  isGradient?: boolean;
  renderModal: (props: {
    isOpen: boolean;
    onClose: () => void;
    setIsLoading: (value: boolean) => void;
  }) => ReactNode;
};

export const OpenModalButton = ({
  btnText,
  renderModal,
  isGradient,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Stack gap="24px">
      {isGradient ? (
        <GradientButton
          onClick={() => setIsOpen(true)}
          startIcon={
            isLoading ? <CircularProgress size={20} color="inherit" /> : null
          }
          disabled={isLoading}
        >
          {btnText}
        </GradientButton>
      ) : (
        <CustomButton
          onClick={() => setIsOpen(true)}
          variant="outlined"
          customColor="#FFFFFF"
          textColor="#BD4D00"
          customSize="fit"
          type="button"
          startIcon={
            isLoading ? <CircularProgress size={20} color="inherit" /> : null
          }
          disabled={isLoading}
          sx={{ borderColor: "#BD4D00" }}
        >
          {btnText}
        </CustomButton>
      )}

      {isOpen &&
        renderModal({
          isOpen,
          onClose: () => setIsOpen(false),
          setIsLoading,
        })}
    </Stack>
  );
};
